// modules/LoadingHelper.js
// 加载提示辅助模块 - 统一管理加载进度和提示

export default class LoadingHelper {
    /**
     * 创建加载进度UI
     * @param {Phaser.Scene} scene - 场景对象
     * @returns {Object} UI元素对象
     */
    static createLoadingUI(scene) {
        const { width, height, centerX, centerY } = scene.cameras.main;
        
        // 背景
        const background = scene.add.rectangle(
            0, 0, width, height, 0x1a1a2e
        ).setOrigin(0, 0);
        
        // 标题
        const title = scene.add.text(
            centerX, centerY - 100,
            '老四出品',
            {
                fontSize: '48px',
                fill: '#4cc9f0',
                fontFamily: 'Arial',
                fontWeight: 'bold'
            }
        ).setOrigin(0.5);
        
        // 加载栏背景
        const barBg = scene.add.graphics();
        barBg.fillStyle(0x333333, 1);
        barBg.fillRect(centerX - 200, centerY, 400, 30);
        barBg.lineStyle(2, 0x4cc9f0, 1);
        barBg.strokeRect(centerX - 200, centerY, 400, 30);
        
        // 加载栏填充
        const barFill = scene.add.graphics();
        
        // 进度文本
        const progressText = scene.add.text(
            centerX, centerY + 50,
            '0%',
            {
                fontSize: '20px',
                fill: '#ffffff',
                fontFamily: 'Arial'
            }
        ).setOrigin(0.5);
        
        // 状态文本
        const statusText = scene.add.text(
            centerX, centerY + 90,
            '正在初始化...',
            {
                fontSize: '16px',
                fill: '#aaaaaa',
                fontFamily: 'Arial'
            }
        ).setOrigin(0.5);
        
        // 提示文本
        const tipText = scene.add.text(
            centerX, height - 50,
            '请稍候，正在加载游戏资源...',
            {
                fontSize: '14px',
                fill: '#666666',
                fontFamily: 'Arial',
                fontStyle: 'italic'
            }
        ).setOrigin(0.5);
        
        return {
            background,
            title,
            barBg,
            barFill,
            progressText,
            statusText,
            tipText
        };
    }
    
    /**
     * 更新加载进度
     * @param {Object} ui - UI元素对象
     * @param {number} progress - 进度值 (0-100)
     * @param {string} status - 状态文本
     */
    static updateProgress(ui, progress, status = '') {
        if (!ui) return;
        
        const progressValue = Phaser.Math.Clamp(progress, 0, 100);
        
        // 更新进度条
        if (ui.barFill) {
            ui.barFill.clear();
            ui.barFill.fillStyle(0x4cc9f0, 1);
            const barWidth = (progressValue / 100) * 400;
            ui.barFill.fillRect(
                ui.barFill.scene.cameras.main.centerX - 200,
                ui.barFill.scene.cameras.main.centerY,
                barWidth,
                30
            );
        }
        
        // 更新进度文本
        if (ui.progressText) {
            ui.progressText.setText(`${Math.round(progressValue)}%`);
        }
        
        // 更新状态文本
        if (ui.statusText && status) {
            ui.statusText.setText(status);
        }
    }
    
    /**
     * 显示加载提示
     * @param {Object} ui - UI元素对象
     * @param {string} message - 提示消息
     */
    static showTip(ui, message) {
        if (ui && ui.tipText) {
            ui.tipText.setText(message);
        }
    }
    
    /**
     * 销毁加载UI
     * @param {Object} ui - UI元素对象
     */
    static destroy(ui) {
        if (!ui) return;
        
        if (ui.background) ui.background.destroy();
        if (ui.title) ui.title.destroy();
        if (ui.barBg) ui.barBg.destroy();
        if (ui.barFill) ui.barFill.destroy();
        if (ui.progressText) ui.progressText.destroy();
        if (ui.statusText) ui.statusText.destroy();
        if (ui.tipText) ui.tipText.destroy();
    }
}

